import { atom } from "recoil";

const timeDurationAtom = atom({
  key: "timeDurationState",
  default: 0,
});

export default timeDurationAtom;
